function toggleSubMenu(event) 
{
    console.log("toggleSubMenu triggered");
    event.preventDefault();
    //console.log("toggleSubMenu triggered");
    //event.preventDefault();
    let submenu = event.target.nextElementSibling;
    if (!submenu) submenu = event.target.parentElement.nextElementSibling;
    const chevron = event.currentTarget.querySelector('.chevron');
    if (submenu.style.display === "none") {
        submenu.style.display = "block";
        chevron.textContent = '▼';
    } else {
        submenu.style.display = "none";
        chevron.textContent = '◀';
    }
}

function scrollToAnchorIfPresent() 
{
    const hash = window.location.hash;
    if (hash) {
        const element = document.querySelector(hash);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }
}

function destroyElement(id) 
{
    const element = document.getElementById(id);
    if (element) {
        element.remove();
    }
}

function navratNaHlavniStrankuPublic() 
{
    window.location.href = './';
}

function preloadScript(url) 
{
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'script';
    link.href = url;
    document.head.appendChild(link);
}

function preloadCSS(url) 
{
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'style';
    link.href = url;
    document.head.appendChild(link);
}

function clearGovCookies() 
{
    // Get all cookies
    const cookies = document.cookie.split(';');
    
    cookies.forEach(cookie => {
        const [name] = cookie.trim().split('=');

        // Specify Google Analytics cookies
        if (name.startsWith('_ga') || name.startsWith('gcc_') || name.startsWith('_hj')) {
            // Resets the cookie with empty value and expired validity === deletion
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.gov.cz;`;
        }
    });
}

function getValidSetting(setting, fallback, settingsContext) {
    if (setting === undefined || setting === null) {
        console.warn(`Invalid value for ${settingsContext}, falling back to default:`, fallback);
        return fallback;
    }
    if (typeof setting === 'number' && isNaN(setting)) {
        console.warn(`Invalid number for ${settingsContext}, falling back to default:`, fallback);
        return fallback;
    }
    return setting;
}

function showLogoffDialog() {

    console.log("pressed showLogoffDialog");
    // Create overlay
    const overlay = document.createElement('div');
    overlay.setAttribute('id', 'overlay');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    overlay.style.zIndex = '999';
    overlay.addEventListener('click', (event) => {
        if (event.target === overlay) {
            document.body.removeChild(dialog);
            document.body.removeChild(overlay);
        }
    });

    const dialog = document.createElement('div');
    dialog.setAttribute('id', 'logoff-dialog');
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-labelledby', 'logoff-dialog-title');
    dialog.setAttribute('aria-modal', 'true');
    dialog.style.position = 'fixed';
    dialog.style.top = '30%';
    dialog.style.left = '50%';
    dialog.style.transform = 'translate(-50%, -50%)';
    dialog.style.backgroundColor = 'inherit';
    dialog.style.padding = '30px';
    dialog.style.borderRadius = '10px';
    dialog.style.zIndex = '1000';
    dialog.addEventListener('gov-click', (e) => {
        e.stopPropagation();
    });

    const title = document.createElement('h2');
    title.setAttribute('id', 'logoff-dialog-title');
    title.innerText = 'Odhlášení z portálu';
    dialog.appendChild(title);

    const message = document.createElement('p');
    message.innerHTML = 'Chcete se skutečně odhlásit ?<br /><br />';
    dialog.appendChild(message);

    const buttonsContainer = document.createElement('div');
    buttonsContainer.style.display = 'flex';
    buttonsContainer.style.justifyContent = 'space-between';

    const cancelButton = document.createElement('gov-button');
    cancelButton.setAttribute('variant', 'primary');
    cancelButton.setAttribute('type', 'outlined');
    cancelButton.setAttribute('native-type', 'button');
    cancelButton.setAttribute('size', 'm');
    cancelButton.setAttribute('wcag-label', 'Tlačítko zrušení odhlášení z portálu');
    cancelButton.innerText = 'Zůstat';
    cancelButton.addEventListener('gov-click', () => {
        document.body.removeChild(dialog);
        document.body.removeChild(overlay);
    });
    buttonsContainer.appendChild(cancelButton);

    const confirmButton = document.createElement('gov-button');
    confirmButton.setAttribute('variant', 'primary');
    confirmButton.setAttribute('type', 'solid');
    confirmButton.setAttribute('native-type', 'button');
    confirmButton.setAttribute('size', 'm');
    confirmButton.setAttribute('wcag-label', 'Tlačítko odhlášení z portálu');
    confirmButton.innerText = 'Odhlásit';
    confirmButton.addEventListener('gov-click', () => {
        window.location.href = '/Odhlasit';
    });
    buttonsContainer.appendChild(confirmButton);

    dialog.appendChild(buttonsContainer);
    document.body.appendChild(overlay);
    document.body.appendChild(dialog);

}

const sanitizeHtml = (html) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Remove potentially dangerous attributes from all elements
    const dangerousAttributes = ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur'];
    const allElements = tempDiv.getElementsByTagName('*'); // Get all elements
    for (let i = 0; i < allElements.length; i++) {
        dangerousAttributes.forEach(attr => {
            allElements[i].removeAttribute(attr);
        });
    }

    const scripts = tempDiv.getElementsByTagName('script');
    while (scripts.length > 0) {
        scripts[0].parentNode.removeChild(scripts[0]);
    }

    return tempDiv.innerHTML;
};

export { toggleSubMenu, scrollToAnchorIfPresent, navratNaHlavniStrankuPublic, destroyElement, preloadScript, preloadCSS, clearGovCookies, getValidSetting, showLogoffDialog, sanitizeHtml };